module.exports = {
  production: false,
  api: "https://api.osm.waterdog.mobi/v1/backoffice",
  amplify: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_hA4rnNO19",
    userPoolWebClientId: "6hfe0prqqtdnf0q6ad8jgsrg02",
  },
};
